import { useState } from "react";
import { Button, Dialog } from "@rio-cloud/rio-uikit";

interface IEstimatedRepairTimeDialogProps {
  showDialog: boolean;
  onClose: () => void;
  onConfirm: (estimateTimeRepair: string) => void;
  loading?: boolean;
}

export const daysAndHoursToEstimateTimeRepair = (days: number, hours: number): string => {
  const totalHours = days * 24 + hours;
  return `${String(totalHours).padStart(2, "0")}:00`;
};

const EstimatedRepairTimeDialog = ({
  showDialog,
  onClose,
  onConfirm,
  loading = false,
}: IEstimatedRepairTimeDialogProps) => {
  const [days, setDays] = useState<string>("");
  const [hours, setHours] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleHoursChange = (value: string) => {
    const hoursValue = Number(value) || 0;

    if (hoursValue < 24) {
      setHours(value);
      return;
    }

    const extraDays = Math.floor(hoursValue / 24);
    const remainingHours = hoursValue % 24;

    setDays((prevDays) => String((Number(prevDays) || 0) + extraDays));
    setHours(String(remainingHours));
  };

  const handleConfirm = () => {
    const daysValue = Number(days) || 0;
    const hoursValue = Number(hours) || 0;

    if (daysValue <= 0 && hoursValue <= 0) {
      setError("Informe ao menos os dias ou as horas previstas para o reparo.");
      return;
    }

    setError("");
    onConfirm(daysAndHoursToEstimateTimeRepair(daysValue, hoursValue));
    setDays("");
    setHours("");
  };

  const handleClose = () => {
    setDays("");
    setHours("");
    setError("");
    onClose();
  };

  return (
    <Dialog
      show={showDialog}
      title="Tempo previsto para o reparo"
      body={
        <div className="space-y-4">
          <p className="text-gray-600">
            Para mover o chamado para a etapa Reparo, informe o tempo previsto de conclusão
            (dias e/ou horas).
          </p>

          <div className="flex gap-4">
            <div className="form-group form-group-lg w-full">
              <label htmlFor="estimatedRepairDays">Dias</label>
              <input
                id="estimatedRepairDays"
                type="number"
                min={0}
                placeholder="0"
                className="form-control"
                value={days}
                onChange={(e) => setDays(e.target.value)}
              />
            </div>

            <div className="form-group form-group-lg w-full">
              <label htmlFor="estimatedRepairHours">Horas</label>
              <input
                id="estimatedRepairHours"
                type="number"
                min={0}
                max={23}
                placeholder="00"
                className="form-control"
                value={hours}
                onChange={(e) => handleHoursChange(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="text-red-600 bg-red-50 border border-red-200 rounded-md p-3">
              {error}
            </div>
          )}
        </div>
      }
      footer={
        <div className="display-flex justify-content-end">
          <Button
            bsStyle="default"
            onClick={handleClose}
            className="margin-right-10"
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            bsStyle="primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Confirmando..." : "Confirmar"}
          </Button>
        </div>
      }
      bsSize={Dialog.SIZE_MD}
      onClose={handleClose}
    />
  );
};

export default EstimatedRepairTimeDialog;
